// src/components/common/EmptyState.js
import React from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';
import { SearchOff as SearchOffIcon } from '@mui/icons-material';

/**
 * EmptyState component to show when there are no results to display
 */
const EmptyState = ({ 
  title = 'No results found', 
  message = 'Try adjusting your search or filters.',
  icon: Icon = SearchOffIcon,
  height = 200 
}) => {
  const theme = useTheme();
  
  return (
    <Box 
      display="flex" 
      flexDirection="column"
      justifyContent="center" 
      alignItems="center" 
      height={height}
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: '12px',
        boxShadow: `0 8px 16px ${alpha('#000', 0.05)}`,
        p: 3,
      }}
    >
      <Box 
        sx={{
          width: 60,
          height: 60,
          borderRadius: '50%',
          backgroundColor: alpha(theme.palette.primary.main, 0.1),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: alpha(theme.palette.primary.main, 0.7),
          mb: 2,
        }}
      >
        <Icon fontSize="large" />
      </Box>
      <Typography variant="h6" color="text.primary" fontWeight="medium" align="center">
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1, maxWidth: 400 }}>
        {message}
      </Typography>
    </Box>
  );
};

export default EmptyState;